export default __webpack_public_path__ + "static/media/rezy.6a34a408.png";